function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.9161 9.11234V8.40734C16.9161 4.53834 13.8921 1.40234 10.1661 1.40234C6.44008 1.40234 3.41608 4.53834 3.41608 8.40734V9.11234C3.41728 9.9539 3.17712 10.7781 2.72408 11.4873L1.61608 13.2123C0.605078 14.7873 1.37708 16.9283 3.13608 17.4263C7.73237 18.728 12.5998 18.728 17.1961 17.4263C18.9551 16.9283 19.7271 14.7873 18.7161 13.2133L17.6081 11.4883C17.1547 10.7793 16.9142 9.955 16.9151 9.11334L16.9161 9.11234Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66602 18.4023C6.32102 20.1503 8.08802 21.4023 10.166 21.4023C12.244 21.4023 14.011 20.1503 14.666 18.4023",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3628b226d3da34e860713297a74143ef.svg";
export { ForwardRef as ReactComponent };